// extracted by mini-css-extract-plugin
module.exports = {"aside":"Aside_aside__1u4y7","fadeInLeft":"Aside_fadeInLeft__1V3YJ","overlay":"Aside_overlay__1bxYy"};